import { DecommissionReason, DeviceBillingState } from '@ixicare/resources';
import { t } from '~i18n';

/**
 * What state a piece of hardware is in, in the words the dashboard uses.
 *
 * Deliberately not the backend's billing vocabulary: partners bill their own customers on
 * their own terms, so what Ixi invoices them for is not something to put in front of them.
 * DECOMMISSIONED and NOT_IN_SERVICE are facts the device list cannot show otherwise — the
 * remaining two are the archived flag, which is where this reads them from.
 */
const STATE_KEYS: Partial<Record<DeviceBillingState, string>> = {
  [DeviceBillingState.DECOMMISSIONED]: 'device.state.decommissioned',
  [DeviceBillingState.NOT_IN_SERVICE]: 'device.state.notInService',
};

export const deviceStateLabel = (billingState: DeviceBillingState | undefined, isArchived: boolean): string => {
  const key = billingState && STATE_KEYS[billingState];
  return key ? t(key) : t(isArchived ? 'device.state.archived' : 'device.state.unarchived');
};

export const isDecommissioned = (item: { billingState?: DeviceBillingState }): boolean =>
  item.billingState === DeviceBillingState.DECOMMISSIONED;

// Spelled out rather than derived from the enum value: translation keys are camelCase,
// the backend's are SCREAMING_SNAKE.
const REASON_KEYS: Record<DecommissionReason, string> = {
  [DecommissionReason.BROKEN]: 'device.decommission.reasons.broken',
  [DecommissionReason.DAMAGED]: 'device.decommission.reasons.damaged',
  [DecommissionReason.LOST_OR_STOLEN]: 'device.decommission.reasons.lostOrStolen',
  [DecommissionReason.RETURNED_TO_IXI]: 'device.decommission.reasons.returnedToIxi',
  [DecommissionReason.REPLACED]: 'device.decommission.reasons.replaced',
  [DecommissionReason.ENTERED_IN_ERROR]: 'device.decommission.reasons.enteredInError',
  [DecommissionReason.OTHER]: 'device.decommission.reasons.other',
};

export const decommissionReasonLabel = (reason: DecommissionReason): string => t(REASON_KEYS[reason]);
